import React from "react";
import AccountManagerTabs from "./AccountManager/AccountManagerTabs";

function AccountManagerDashboard(props) {
    return (
        <div className="row">
            <div className="col-xl-12">
                <div className="card">
                    <div className="card-body">

                        <AccountManagerTabs accountsData={props.accountsData}/>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default (AccountManagerDashboard);

